/**
 * Wrap a promise with a timeout. If `ms` elapses first, rejects with a
 * clear error. Prevents UI getting stuck on "Saving…" / "Posting…"
 * when a Supabase call hangs (auth-token refresh race, network stall).
 */
export function withTimeout<T>(p: Promise<T>, ms: number, label = 'operation'): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const t = setTimeout(() => reject(new Error(`${label} timed out after ${ms}ms`)), ms);
    p.then(
      (v) => { clearTimeout(t); resolve(v); },
      (e) => { clearTimeout(t); reject(e); },
    );
  });
}
